import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

export type EventServiceType = "success" | "error"

@Injectable({
    providedIn: 'root'
})
export class EventService {

    private onPageLoad: BehaviorSubject<EventServiceType> = new BehaviorSubject<EventServiceType>(null);

    emitPageLoadEvent(msg: EventServiceType){
        this.onPageLoad.next(msg);
    }

    pageLoadEventListener(){
        if(this.onPageLoad.closed) {
            this.onPageLoad = new BehaviorSubject<EventServiceType>(null);
        }

        return this.onPageLoad.asObservable();
    }

    unsubscribe() {
        this.onPageLoad.unsubscribe();
    }
}
